import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button, TextField, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, InputAdornment } from '@mui/material';
import PaginacionControl from '../components/PaginacionControl';
import SearchIcon from '@mui/icons-material/Search';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { GridOn } from '@mui/icons-material';
import axios from 'axios';

const API_URL = '/api/marcas';

const Marcas = () => {
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(8);
  const [marcas, setMarcas] = useState([]);
  const [open, setOpen] = useState(false);
  const [nombre, setNombre] = useState('');
  const [editId, setEditId] = useState(null);

  const fetchMarcas = async () => {
    const res = await axios.get(API_URL);
    setMarcas(res.data);
  };

  useEffect(() => {
    fetchMarcas();
  }, []);

  const handleOpen = (marca = null) => {
    if (marca) {
      setEditId(marca.id);
      setNombre(marca.nombre);
    } else {
      setEditId(null);
      setNombre('');
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setNombre('');
    setEditId(null);
  };

  const handleSave = async () => {
    try {
      if (editId) {
        await axios.put(`${API_URL}/${editId}`, { nombre });
      } else {
        await axios.post(API_URL, { nombre });
      }
      fetchMarcas();
      handleClose();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al guardar');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Eliminar esta marca?')) {
      try {
        await axios.delete(`${API_URL}/${id}`);
        fetchMarcas();
      } catch { alert('Error al eliminar'); }
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1, mb: 4, width: '100%' }}>
      <Box sx={{ width: { xs: '100%', sm: '95%', md: '90%' }, maxWidth: 1800, mt: { xs: '0em', sm: '0em', md: '0em' } }}>
        <Typography variant="h4" gutterBottom sx={{ textAlign: { xs: 'center', md: 'left' }, mb: 3, fontWeight: 'bold', color: '#222' }}>Marcas</Typography>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
          <TextField
            placeholder="Buscar..."
            value={searchValue}
            onChange={e => { setSearchValue(e.target.value); setPage(0); }}
            size="small"
            InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment> }}
            sx={{ flex: 1 }}
          />
          <Button color="success" variant="contained" startIcon={<GridOn />} sx={{ minWidth: 120 }} onClick={async () => {
            const { exportGenericWorkbook } = await import('../utils/excel/genericWorkbook');
            const rows = marcas
              .filter(marca => marca.nombre.toLowerCase().includes(searchValue.toLowerCase()))
              .map(marca => ({ id: marca.id, nombre: marca.nombre }));
            await exportGenericWorkbook({
              titulo: 'REPORTE DE MARCAS',
              sheetName: 'Marcas',
              tableName: 'tblMarcas',
              fileName: 'Marcas',
              columns: [
                { key: 'id', label: 'ID', width: 8 },
                { key: 'nombre', label: 'Nombre', width: 26 }
              ],
              rows,
              searchText: searchValue,
              usuario: ''
            });
          }}>
            Exportar Excel
          </Button>
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => handleOpen()} sx={{ ml: { xs: 0, sm: 'auto' }, mt: { xs: 2, sm: 0 } }}>Nueva Marca</Button>
          <TextField
            size="small"
            label="Mostrar"
            type="number"
            value={rowsPerPage}
            onChange={e => { setRowsPerPage(Number(e.target.value)); setPage(0); }}
            sx={{ width: 100 }}
          />
        </Box>
      <TableContainer component={Paper} sx={{ borderRadius: 4, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', mt: 2, overflowX: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ pr: 8 }}>ID</TableCell>
              <TableCell align="center">Nombre</TableCell>
              <TableCell align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {marcas
              .filter(marca => marca.nombre.toLowerCase().includes(searchValue.toLowerCase()))
              .slice(rowsPerPage === -1 ? 0 : page * rowsPerPage, rowsPerPage === -1 ? undefined : (page + 1) * rowsPerPage)
              .map((marca) => (
                <TableRow key={marca.id}>
                  <TableCell align="center" sx={{ pr: 8 }}>{marca.id}</TableCell>
                  <TableCell align="center">{marca.nombre}</TableCell>
                  <TableCell align="center">
                    <IconButton color="primary" onClick={() => handleOpen(marca)}><EditIcon /></IconButton>
                    <IconButton color="error" onClick={() => handleDelete(marca.id)}><DeleteIcon /></IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginacionControl
        page={page}
        rowsPerPage={rowsPerPage}
        count={marcas.filter(marca => marca.nombre.toLowerCase().includes(searchValue.toLowerCase())).length}
        onPageChange={setPage}
      />
      <Dialog open={open} onClose={(_, r) => r !== 'backdropClick' && handleClose()} disableEscapeKeyDown={false} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography variant="h5" fontWeight="bold">
            {editId ? 'Editar Marca' : 'Nueva Marca'}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Nombre"
            value={nombre}
            onChange={e => setNombre(e.target.value)}
            fullWidth
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} startIcon={<CloseIcon />} color="error" variant="contained">Cancelar</Button>
          <Button onClick={handleSave} variant="contained" startIcon={<SaveIcon />} color="primary">Guardar</Button>
        </DialogActions>
      </Dialog>
    </Box>
    </Box>
  );
};

export default Marcas;
